import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';

export const ClientFieldPaymentSuccessPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state || {};

  const bookingRef = state.bookingRef || 'SP-BK-202608-0091';
  const arenaName = state.arenaName || 'HK 99 Mini Soccer';
  const fieldName = state.fieldName || 'Lapangan A · Sintetis';
  const formattedDate = state.formattedDate || '07 Agustus 2026';
  const durationText = state.durationText || '16.00 (1 jam)';
  const methodName = state.selectedMethod?.name || 'QRIS';
  const grandTotal = state.grandTotal || 180000;

  return (
    <div className="bg-[#F8FAFC] min-h-screen pt-8 px-4 max-w-md mx-auto space-y-6 text-center">
      {/* Success Badge Banner */}
      <div className="space-y-3 pt-4">
        <div className="w-20 h-20 rounded-full bg-emerald-50 border-4 border-emerald-100 flex items-center justify-center mx-auto shadow-sm animate-bounce">
          <Icon icon="ph:check-circle-fill" className="w-12 h-12 text-emerald-500" />
        </div>
        <h1 className="text-xl font-extrabold text-[#0E1726]">Pembayaran Berhasil!</h1>
        <p className="text-xs text-gray-500 font-medium px-4">
          Pesanan booking lapangan kamu telah terkonfirmasi. Silakan tunjukkan tiket booking saat tiba di lokasi.
        </p>
      </div>

      {/* Booking Summary Card */}
      <div className="bg-white rounded-3xl p-5 border border-gray-100 shadow-2xs space-y-4 text-left">
        <div className="flex items-center justify-between border-b border-gray-100 pb-3">
          <span className="text-xs text-gray-400 font-medium">No. Referensi</span>
          <span className="text-xs font-mono font-extrabold text-[#FC480D] bg-orange-50 px-2.5 py-1 rounded-full border border-orange-100">
            {bookingRef}
          </span>
        </div>

        <div className="space-y-2">
          <h3 className="text-sm font-extrabold text-[#0E1726]">{arenaName}</h3>
          <p className="text-xs text-gray-400 font-semibold">{fieldName}</p>
        </div>

        <div className="border-t border-b border-gray-100 py-3 space-y-2 text-xs">
          <div className="flex items-center justify-between">
            <span className="text-gray-400 font-medium">Tanggal</span>
            <span className="font-bold text-[#0E1726]">{formattedDate}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-gray-400 font-medium">Jam Main</span>
            <span className="font-bold text-[#0E1726]">{durationText}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-gray-400 font-medium">Metode Bayar</span>
            <span className="font-bold text-[#0E1726]">{methodName}</span>
          </div>
        </div>

        <div className="flex items-center justify-between text-sm pt-1">
          <span className="font-extrabold text-[#0E1726]">Total Dibatalkan/Dibayar</span>
          <span className="font-extrabold text-[#FC480D] text-base">
            Rp. {grandTotal.toLocaleString('id-ID')}
          </span>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="space-y-2.5 pt-2">
        <button
          type="button"
          onClick={() => navigate('/booking')}
          className="w-full py-3.5 rounded-full bg-[#FC480D] hover:bg-[#D83B08] text-white text-xs font-extrabold shadow-md active:scale-98 transition-all cursor-pointer flex items-center justify-center gap-2"
        >
          <Icon icon="ph:ticket-bold" className="w-4 h-4" />
          <span>Lihat Tiket Booking Saya</span>
        </button>

        <button
          type="button"
          onClick={() => navigate('/')}
          className="w-full py-3.5 rounded-full bg-white border border-gray-200 text-gray-700 hover:bg-gray-50 text-xs font-extrabold active:scale-98 transition-all cursor-pointer"
        >
          Kembali ke Beranda
        </button>
      </div>
    </div>
  );
};
